@if (activeNaviSection(); as section) {
  <fcom-sidebar-nav
    [activeNavItem]="activeNaviItem()"
    [activeNavSection]="activeNaviSection()"
    [nested]="nested()"
    [title]="title()"
    [showTitle]="showTitle()"
    [topSpacing]="topSpacing()"
    [bottomSpacing]="bottomSpacing()"
    [theme]="theme()"
    data-elastic-exclude
  ></fcom-sidebar-nav>
}
